import cn from 'clsx'

import React, { Component } from 'react'
import InlineSVG from 'svg-inline-react'
import Icon, { IconKey } from 'components/ui/icon'

type Props = React.ComponentProps<'label'> & {
  active?: boolean
  className?: string
  disabled?: boolean
  hidden?: boolean
  label: any
  icon?: IconKey
  onActive?: (...args: Array<any>) => any
  onClick?: (...args: Array<any>) => any
  children?: React.ReactNode
} // TODO: Clean up

export default class Tab extends Component<Props> {
  static defaultProps: {
    active: boolean
    className: string
    disabled: boolean
    hidden: boolean
  } = {
    active: false,
    className: '',
    disabled: false,
    hidden: false,
  }

  componentDidUpdate(prevProps: Props) {
    if (!prevProps.active && this.props.active && this.props.onActive) {
      this.props.onActive()
    }
  }

  _handleClick: (event: React.MouseEvent<EventTarget>) => void = (
    event: React.MouseEvent<any>,
  ) => {
    if (!this.props.disabled && this.props.onClick) {
      this.props.onClick(event)
    }
  }

  render(): React.ReactElement<'label'> {
    const {
      onActive,
      active,
      className,
      label,
      icon,
      disabled,
      hidden,
      ...other
    } = this.props
    const rootClass = cn(
      'Tab_Label',
      {
        Tab_Active: active,
        Tab_Hidden: hidden,
        Tab_Disabled: disabled,
      },
      className,
    )
    return (
      <label {...other} className={rootClass} onClick={this._handleClick}>
        {icon && (
          <InlineSVG
            className="Tab_Icon"
            src={require(`!svg-inline!assets/icons/${icon}.svg`)}
          />
        )}
        {label}
      </label>
    )
  }
}
